(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
    static isScroll = false;
    static scrollCleanup = null;

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);
      this.sections = [];
      this.currentSection = null;
      this.targetElement = null;
      this.observer = null;
    }

    connectedCallback() {
      this.refreshSections();
      this.refreshTarget();
      this.addEventListener('click', this.itemClick);
      this.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.setupObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
      this.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.teardownObserver();
    }

    handleResize() {
      this.refreshSections();
      this.setupObserver();
    }

    handleKeydown(event) {
      if (event.key != 'Enter' && event.key != ' ') {
        return;
      }

      event.preventDefault();
      this.itemClick();
    }

    refreshTarget() {
      const sectionNumber = Number(this.getAttribute('data-section-number') || 0);

      if (!Number.isFinite(sectionNumber) || sectionNumber <= 0) {
        this.targetElement = null;
        return;
      }

      this.targetElement = this.sections[sectionNumber - 1] || null;
    }

    refreshSections() {
      const mainRoot =
        document.getElementById('MainContent') || document.getElementById('main') || document.querySelector('main');
      const allSections = mainRoot
        ? Array.from(mainRoot.querySelectorAll('.shopify-section'))
        : Array.from(document.querySelectorAll('.shopify-section'));
      this.currentSection = this.closest('.shopify-section');
      this.sections = allSections;
    }

    setupObserver() {
      this.refreshTarget();
      this.teardownObserver();

      if (!this.targetElement) {
        return;
      }

      const topOffset = this.getVisibleHeaderHeight() + this.getStickyHeight() + 12;
      const observerBandHeight = 24;
      const bottomOffset = Math.max(window.innerHeight - topOffset - observerBandHeight, 0);

      this.observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        threshold: 0.01,
        rootMargin: `-${topOffset}px 0px -${bottomOffset}px 0px`,
      });

      this.observer.observe(this.targetElement);
    }

    teardownObserver() {
      if (!this.observer) {
        return;
      }

      this.observer.disconnect();
      this.observer = null;
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || YGAnchorItem.isScroll) {
          return;
        }

        this.setActiveFromObserver();
      });
    }

    getGroupItems() {
      const id = this.getAttribute('data-id');

      if (id) {
        return Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`));
      }

      if (this.parentElement) {
        return Array.from(this.parentElement.querySelectorAll('yg-anchor-item'));
      }

      return [this];
    }

    setActiveFromObserver() {
      const currentSectionNumber = this.getAttribute('data-section-number') || '';

      this.getGroupItems().forEach((item) => {
        const isActive = item.getAttribute('data-section-number') === currentSectionNumber;

        item.classList.toggle('active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
          item.centerIntoView();
        } else {
          item.removeAttribute('aria-current');
        }
      });

      document.dispatchEvent(
        new CustomEvent('YG:anchor-change', {
          bubbles: true,
        })
      );
    }

    centerIntoView() {
      const parent = this.parentElement;

      if (!parent || parent.scrollWidth <= parent.clientWidth) {
        return;
      }

      const nextLeft = this.offsetLeft - Math.max((parent.clientWidth - this.offsetWidth) / 2, 0);

      parent.scrollTo({
        left: nextLeft,
        behavior: 'smooth',
      });
    }

    getVisibleHeaderHeight() {
      const header = document.querySelector('header.shopify-section-header-sticky:not(.shopify-section-header-hidden)');

      if (!header) {
        return 0;
      }

      return header.getBoundingClientRect().height;
    }

    getStickyHeight() {
      if (!this.currentSection) {
        return 0;
      }

      return this.currentSection.getBoundingClientRect().height;
    }

    itemClick() {
      this.refreshSections();
      this.refreshTarget();

      if (!this.targetElement) {
        return;
      }

      const offsetTop =
        this.targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        this.getVisibleHeaderHeight() -
        this.getStickyHeight() -
        12;
      const targetScrollTop = Math.max(offsetTop, 0);

      YGAnchorItem.isScroll = true;
      this.setActiveFromObserver();

      window.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth',
      });

      this.waitForScrollEnd(targetScrollTop);
    }

    waitForScrollEnd(targetScrollTop) {
      if (YGAnchorItem.scrollCleanup) {
        YGAnchorItem.scrollCleanup();
      }

      let frame = null;
      let timeout = null;
      let lastScrollTop = window.scrollY;
      let stillFrames = 0;

      const cleanup = () => {
        if (frame) {
          window.cancelAnimationFrame(frame);
        }

        if (timeout) {
          window.clearTimeout(timeout);
        }

        window.removeEventListener('scrollend', finish);

        if (YGAnchorItem.scrollCleanup === cleanup) {
          YGAnchorItem.scrollCleanup = null;
        }
      };

      const refreshGroupObservers = () => {
        this.getGroupItems().forEach((item) => {
          item.refreshSections();
          item.setupObserver();
        });
      };

      const finish = () => {
        cleanup();
        YGAnchorItem.isScroll = false;
        refreshGroupObservers();
      };

      const checkScrollPosition = () => {
        const currentScrollTop = window.scrollY;
        const reachedTarget = Math.abs(currentScrollTop - targetScrollTop) <= 2;
        const hasStopped = Math.abs(currentScrollTop - lastScrollTop) <= 0.5;

        stillFrames = hasStopped ? stillFrames + 1 : 0;
        lastScrollTop = currentScrollTop;

        if (reachedTarget || stillFrames >= 8) {
          finish();
          return;
        }

        frame = window.requestAnimationFrame(checkScrollPosition);
      };

      YGAnchorItem.scrollCleanup = cleanup;
      window.addEventListener('scrollend', finish, { once: true });
      timeout = window.setTimeout(finish, 4000);
      frame = window.requestAnimationFrame(checkScrollPosition);
    }
  }

  if (!window.customElements.get('yg-anchor-item')) {
    window.customElements.define('yg-anchor-item', YGAnchorItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-blog-article-nav"] && !Shopify.designMode) return;
  try {
    if (!window.YGBlogArticleNav) {
    window.YGBlogArticleNav = {
      mobileMedia: window.matchMedia('(max-width: 767px)'),
      tabletMedia: window.matchMedia('(min-width: 768px) and (max-width: 1199px)'),

      getProgress: function (articleTop, articleHeight, viewportHeight) {
        var safeHeight = Math.max(articleHeight, 1);
        var viewportDepth = viewportHeight - articleTop;
        return Math.min(1, Math.max(0, viewportDepth / safeHeight));
      },

      findActiveIndex: function (headingTops, activationOffset) {
        var activeIndex = 0;

        headingTops.forEach(function (top, index) {
          if (top <= activationOffset) activeIndex = index;
        });

        return activeIndex;
      },

      /* Theme CSS vars — stable whether header is already stuck or not. */
      getStickyStackOffset: function () {
        var styles = getComputedStyle(document.documentElement);
        var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;
        var announcement = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
        var enableHeader = parseFloat(styles.getPropertyValue('--enable-sticky-header'));
        var enableAnnouncement = parseFloat(styles.getPropertyValue('--enable-sticky-announcement-bar'));

        /* Article TOC forces sticky header; always include header height when nav is on page. */
        if (document.querySelector('[data-yg-blog-article-nav]')) {
          enableHeader = 1;
        } else if (isNaN(enableHeader)) {
          enableHeader = 1;
        }
        if (isNaN(enableAnnouncement)) enableAnnouncement = 0;

        return header * enableHeader + announcement * enableAnnouncement;
      },

      /**
       * Live bottom edge of site chrome currently covering the top of the viewport.
       * Shrinks when top category / announcement bars leave; grows again when they return.
       */
      getVisibleStickyBottom: function () {
        var maxBottom = 0;
        var tocRoot = document.querySelector('[data-yg-blog-article-nav]');

        function isToc(el) {
          return !!(tocRoot && el && (el === tocRoot || tocRoot.contains(el) || el.contains(tocRoot)));
        }

        function isMainContent(el) {
          if (!el || !el.closest) return false;
          return !!el.closest(
            '[data-yg-blog-article-banner], [data-yg-blog-article-main], [data-post-content], .yg-blog-article-nav-host, .yg-blog-article-nav-spacer, #MainContent main, main#MainContent'
          );
        }

        function consider(el) {
          if (!el || el.nodeType !== 1 || isToc(el)) return;
          if (el.classList && el.classList.contains('yg-blog-article-nav-host')) return;

          var rect = el.getBoundingClientRect();
          if (rect.height <= 0 || rect.bottom <= 0 || rect.bottom > 360) return;

          /* Occupies the top edge (stuck) or sits in the upper chrome band. */
          if (rect.top <= 2) {
            maxBottom = Math.max(maxBottom, rect.bottom);
            return;
          }

          if (rect.top < 240) {
            var style = window.getComputedStyle(el);
            var isChrome =
              style.position === 'sticky' ||
              style.position === 'fixed' ||
              (el.id && el.id.indexOf('header') !== -1) ||
              (el.id && el.id.indexOf('announcement') !== -1) ||
              el.matches(
                'header, store-header, .shopify-section-header-sticky, .announcement-bar, [id*="announcement"]'
              );
            if (isChrome) maxBottom = Math.max(maxBottom, rect.bottom);
          }
        }

        consider(document.querySelector('#shopify-section-header'));
        consider(document.querySelector('.shopify-section-header-sticky'));
        consider(document.querySelector('store-header'));
        consider(document.querySelector('header[role="banner"]'));
        consider(document.querySelector('header.header'));

        /* Every section that still intersects the top of the viewport (category strip returns here). */
        document.querySelectorAll('.shopify-section, store-header, header').forEach(function (section) {
          if (isToc(section) || isMainContent(section)) return;
          var rect = section.getBoundingClientRect();
          if (rect.height <= 0 || rect.bottom <= 0) return;
          if (rect.top <= 2 && rect.bottom < 320) {
            maxBottom = Math.max(maxBottom, rect.bottom);
            return;
          }
          /* Header block still below a reappearing top bar when scrollY ~ 0. */
          if (rect.top > 2 && rect.top < 200 && rect.bottom < 360) {
            var style = window.getComputedStyle(section);
            if (
              style.position === 'sticky' ||
              style.position === 'fixed' ||
              (section.id && section.id.indexOf('header') !== -1)
            ) {
              maxBottom = Math.max(maxBottom, rect.bottom);
            }
          }
        });

        /*
          Pixel scan down the top of the viewport — catches chrome that is not a .shopify-section
          and correctly grows again when the top bar scrolls back into view.
        */
        var x = Math.min(Math.max(window.innerWidth / 2, 40), 220);
        var y = 0;
        var guard = 0;
        while (y < 300 && guard < 50) {
          guard += 1;
          var hit = document.elementFromPoint(x, y);
          if (!hit) break;

          if (isToc(hit)) {
            y = Math.ceil(tocRoot.getBoundingClientRect().bottom) + 1;
            continue;
          }

          if (isMainContent(hit)) break;

          var chrome = hit.closest(
            '#shopify-section-header, .shopify-section-header-sticky, store-header, header, .shopify-section, .announcement-bar, [id*="announcement"]'
          );

          if (chrome && !isToc(chrome) && !isMainContent(chrome)) {
            var chromeRect = chrome.getBoundingClientRect();
            if (chromeRect.bottom > maxBottom && chromeRect.bottom < 360) {
              maxBottom = chromeRect.bottom;
            }
            if (chromeRect.bottom <= y + 1) {
              y += 8;
            } else {
              y = Math.ceil(chromeRect.bottom) + 1;
            }
            continue;
          }

          y += 8;
        }

        if (maxBottom > 0) return Math.round(maxBottom);
        return Math.round(window.YGBlogArticleNav.getStickyStackOffset());
      },

      /* Prefer live chrome bottom; fall back to theme CSS vars. */
      getHeaderOffset: function () {
        var live = window.YGBlogArticleNav.getVisibleStickyBottom();
        if (live > 0) return live;
        return window.YGBlogArticleNav.getStickyStackOffset();
      },

      /* Prefer last applied measured top; otherwise live measure. */
      getMobileTopOffset: function (root) {
        if (root) {
          var applied = parseFloat(root.style.getPropertyValue('--yg-blog-nav-mobile-top-measured'));
          if (applied > 0) return applied;

          var resolved = parseFloat(getComputedStyle(root).getPropertyValue('--yg-blog-nav-mobile-top'));
          if (resolved > 0) return resolved;
        }

        return window.YGBlogArticleNav.getVisibleStickyBottom();
      },

      getMobileToggleHeight: function (root) {
        if (!root) return 64;
        var styles = getComputedStyle(root);
        var height = parseFloat(styles.getPropertyValue('--yg-blog-nav-toggle-height'));
        return height > 0 ? height : 64;
      },

      /*
        Mobile: recompute TOC top every scroll/resize.
        - Scroll down: top bar leaves → top shrinks (TOC under sticky header only)
        - Scroll back to top: top bar returns → top grows again (TOC under full chrome)
      */
      syncMeasuredMobileTop: function (root) {
        if (!root || !window.YGBlogArticleNav.mobileMedia.matches) {
          if (root) {
            root.style.removeProperty('--yg-blog-nav-mobile-top-measured');
            root.style.removeProperty('top');
          }
          return;
        }

        var measured = window.YGBlogArticleNav.getVisibleStickyBottom();
        if (!(measured > 0)) {
          root.style.removeProperty('--yg-blog-nav-mobile-top-measured');
          root.style.removeProperty('top');
          return;
        }

        var prev = parseFloat(root.style.getPropertyValue('--yg-blog-nav-mobile-top-measured')) || 0;
        var nearTop = window.scrollY < 80;
        /* Near top always force-write so reappearing bars are never missed after fling. */
        if (nearTop || Math.abs(prev - measured) >= 0.5) {
          root.style.setProperty('--yg-blog-nav-mobile-top-measured', measured + 'px');
          /* Inline top beats stale CSS var during momentum scroll. */
          root.style.top = measured + 'px';
        }
      },

      /* Same rule as snippets/blog-navbar.liquid so old #H- URLs keep working. */
      legacySlugFromText: function (text) {
        var slug = String(text || '')
          .toLowerCase()
          .replace(/ /g, '-');

        try {
          slug = slug.replace(/[^\p{L}\p{N}-]+/gu, '');
        } catch (error) {
          slug = slug.replace(/[^a-z0-9\u00c0-\uffff-]+/gi, '');
        }

        return slug.trim();
      },

      legacyIdFromText: function (text, index) {
        var slug = window.YGBlogArticleNav.legacySlugFromText(text);
        if (slug) return 'H-' + slug;
        return 'H-article-section-' + (index + 1);
      },

      shopifyHandleFromText: function (text) {
        return String(text || '')
          .toLowerCase()
          .replace(/['’]/g, '')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      },

      findHeadingForHash: function (raw, headings) {
        if (!raw || !headings || !headings.length) return null;

        var decoded = raw;
        try {
          decoded = decodeURIComponent(raw);
        } catch (error) {
          decoded = raw;
        }

        var byId = document.getElementById(decoded);
        if (byId) return byId;

        for (var i = 0; i < headings.length; i++) {
          var heading = headings[i];
          var text = heading.textContent.trim();
          var legacyId = window.YGBlogArticleNav.legacyIdFromText(text, i);
          var handle = window.YGBlogArticleNav.shopifyHandleFromText(text);
          var slug = window.YGBlogArticleNav.legacySlugFromText(text);
          var candidates = [legacyId, handle, 'H-' + handle, 'yg-article-' + handle];

          if (slug) {
            candidates.push('yg-article-' + slug);
            candidates.push(slug);
          }

          if (candidates.indexOf(decoded) !== -1) return heading;
        }

        return null;
      },

      ensureHeadingIds: function (headings, list) {
        var links = list ? Array.from(list.querySelectorAll('.yg-blog-article-nav__link[href^="#"]')) : [];
        var usedIds = {};

        headings.forEach(function (heading, index) {
          var link = links[index];
          var baseId = window.YGBlogArticleNav.legacyIdFromText(heading.textContent.trim(), index);
          var uniqueId = baseId;
          var suffix = 2;

          while (usedIds[uniqueId]) {
            uniqueId = baseId + '-' + suffix;
            suffix += 1;
          }

          usedIds[uniqueId] = true;
          heading.id = uniqueId;

          if (link) link.setAttribute('href', '#' + uniqueId);
        });
      },

      resolveLegacyHash: function (root, headings) {
        var raw = window.location.hash.replace(/^#/, '');
        if (!raw) return;

        var target = window.YGBlogArticleNav.findHeadingForHash(raw, headings);
        if (!target) return;

        var decoded = raw;
        try {
          decoded = decodeURIComponent(raw);
        } catch (error) {
          decoded = raw;
        }

        if (target.id && decoded !== target.id) {
          window.history.replaceState(null, '', '#' + target.id);
        }

        var api = window.YGBlogArticleNav;
        var isMobile = api.mobileMedia.matches;
        var offset = isMobile
          ? api.getMobileTopOffset(root) + api.getMobileToggleHeight(root)
          : api.getHeaderOffset() + 16;
        var top = window.scrollY + target.getBoundingClientRect().top - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      },

      bind: function (root) {
        if (root.dataset.ygBlogArticleNavInitialized === 'true') return;

        var selector = root.dataset.contentSelector || '[data-post-content]';
        var article = document.querySelector(selector);
        if (!article) return;

        var list = root.querySelector('[data-yg-blog-article-nav-list]');
        if (!list || !list.children.length) return;

        var headings = Array.from(article.querySelectorAll('h2')).filter(function (heading) {
          return heading.textContent.trim().length > 0;
        });
        if (!headings.length) return;

        var api = window.YGBlogArticleNav;
        var toggle = root.querySelector('[data-yg-blog-article-nav-toggle]');
        var panel = root.querySelector('[data-yg-blog-article-nav-panel]');
        var navHost = root.closest('.yg-blog-article-nav-host') || document.querySelector('.yg-blog-article-nav-host');
        var desktopSlot = document.querySelector('[data-yg-blog-article-nav-desktop-slot]');
        var placeholder = document.createComment('yg-blog-article-nav-position');
        var mainColumn =
          article.closest('.yg-blog-article-main__main-column') ||
          article.closest('.t4s-main-article-page') ||
          article.parentNode;
        var articleRow = article.closest('.t4s-article-content') || article;
        var framePending = false;
        var isOpen = !api.mobileMedia.matches;

        if (navHost) {
          navHost.parentNode.insertBefore(placeholder, navHost);
        } else if (root.parentNode) {
          root.parentNode.insertBefore(placeholder, root);
        }

        api.ensureHeadingIds(headings, list);
        root.dataset.ygBlogArticleNavInitialized = 'true';

        function setOpen(nextOpen) {
          isOpen = nextOpen;
          root.classList.toggle('is-open', isOpen);
          toggle.setAttribute('aria-expanded', String(isOpen));
          panel.hidden = api.mobileMedia.matches ? !isOpen : false;
        }

        function setActive(activeIndex) {
          list.querySelectorAll('.yg-blog-article-nav__item').forEach(function (item, index) {
            var isActive = index === activeIndex;
            item.classList.toggle('is-active', isActive);
            var link = item.querySelector('a');
            if (link) {
              if (isActive) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            }
          });
        }

        /* Mobile only: return nav to host so CSS spacer + fixed bar stay paired.
           Position (top) is CSS-only; this runs on breakpoint change, not on scroll. */
        function placeInHost() {
          var host = navHost || document.querySelector('.yg-blog-article-nav-host');

          if (host) {
            host.appendChild(root);
            return;
          }

          var banner =
            document.querySelector('[data-yg-blog-article-banner]') ||
            document.querySelector('.yg-blog-article-banner');
          var bannerSection = banner ? banner.closest('.shopify-section') || banner : null;

          if (bannerSection && bannerSection.parentNode) {
            bannerSection.parentNode.insertBefore(root, bannerSection);
          } else if (mainColumn && mainColumn.contains(article)) {
            mainColumn.insertBefore(root, mainColumn.firstChild);
          } else {
            article.parentNode.insertBefore(root, article);
          }
        }

        /* Tablet/mid layout: after footer (disclaimer + share), before sidebar modules.
           Design order: content → footer → In This Article → related/subscribe. */
        function placeAfterFooter() {
          var footer =
            (mainColumn && mainColumn.querySelector('.yg-blog-article-main__footer')) ||
            document.querySelector('.yg-blog-article-main__footer');

          if (footer && footer.parentNode) {
            footer.parentNode.insertBefore(root, footer.nextSibling);
            return;
          }

          if (articleRow && articleRow.parentNode) {
            articleRow.parentNode.insertBefore(root, articleRow.nextSibling);
            return;
          }

          if (mainColumn) {
            mainColumn.appendChild(root);
          }
        }

        function setLayout() {
          if (api.mobileMedia.matches) {
            placeInHost();
            setOpen(false);
          } else if (api.tabletMedia.matches) {
            placeAfterFooter();
            setOpen(true);
          } else if (desktopSlot) {
            desktopSlot.appendChild(root);
            setOpen(true);
          } else if (placeholder.parentNode) {
            placeholder.parentNode.insertBefore(root, placeholder.nextSibling);
            setOpen(true);
          } else {
            setOpen(true);
          }

          update();
        }

        function update() {
          var isMobile = api.mobileMedia.matches;

          /* Mobile: remeasure sticky chrome bottom each frame so top tracks bars that leave. */
          if (isMobile) {
            api.syncMeasuredMobileTop(root);
          }

          var headerOffset = isMobile ? api.getMobileTopOffset(root) : api.getHeaderOffset();
          var toggleHeight = isMobile ? api.getMobileToggleHeight(root) : 0;
          var articleRect = article.getBoundingClientRect();
          var articleHeight = article.scrollHeight;
          var progress = api.getProgress(articleRect.top, articleHeight, window.innerHeight);
          var activationOffset = headerOffset + (isMobile ? toggleHeight + 16 : 24);
          var headingTops = headings.map(function (heading) {
            return heading.getBoundingClientRect().top;
          });
          var activeIndex = api.findActiveIndex(headingTops, activationOffset);

          if (!isMobile) {
            root.style.setProperty('--yg-blog-nav-sticky-top', Math.round(headerOffset) + 'px');
          }

          root.style.setProperty('--yg-reading-progress', (progress * 100).toFixed(2) + '%');
          setActive(activeIndex);
        }

        function requestUpdate() {
          if (framePending) return;
          framePending = true;
          window.requestAnimationFrame(function () {
            framePending = false;
            update();
          });
        }

        function onResize() {
          api.syncMeasuredMobileTop(root);
          requestUpdate();
        }

        function onBreakpointChange() {
          api.syncMeasuredMobileTop(root);
          setLayout();
        }

        toggle.addEventListener('click', function () {
          if (!api.mobileMedia.matches) return;
          setOpen(!isOpen);
        });

        list.addEventListener('click', function (event) {
          var link = event.target.closest('a[href^="#"]');
          if (!link) return;

          var hrefId = (link.getAttribute('href') || '').replace(/^#/, '');
          var target = window.YGBlogArticleNav.findHeadingForHash(hrefId, headings) || document.getElementById(hrefId);
          if (!target) return;

          event.preventDefault();
          var isMobile = api.mobileMedia.matches;
          var offset = isMobile
            ? api.getMobileTopOffset(root) + api.getMobileToggleHeight(root)
            : api.getHeaderOffset() + 16;
          var top = window.scrollY + target.getBoundingClientRect().top - offset;
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
          window.history.pushState(null, '', '#' + target.id);
          if (isMobile) setOpen(false);
        });

        window.addEventListener('scroll', requestUpdate, { passive: true });
        /* Final settle after fling — critical when top category bar reappears. */
        window.addEventListener('scrollend', requestUpdate, { passive: true });
        window.addEventListener(
          'touchend',
          function () {
            window.requestAnimationFrame(function () {
              api.syncMeasuredMobileTop(root);
              requestUpdate();
            });
          },
          { passive: true }
        );
        window.addEventListener('resize', onResize);
        api.mobileMedia.addEventListener('change', onBreakpointChange);
        api.tabletMedia.addEventListener('change', onBreakpointChange);

        if ('ResizeObserver' in window) {
          var resizeObserver = new ResizeObserver(requestUpdate);
          resizeObserver.observe(article);

          var headerEl =
            document.querySelector('#shopify-section-header') ||
            document.querySelector('.shopify-section-header-sticky');
          if (headerEl) {
            var headerObserver = new ResizeObserver(function () {
              api.syncMeasuredMobileTop(root);
              requestUpdate();
            });
            headerObserver.observe(headerEl);
          }
        }

        api.syncMeasuredMobileTop(root);
        setLayout();
        api.resolveLegacyHash(root, headings);
      },

      init: function (scope) {
        var context = scope || document;
        var roots =
          context.matches && context.matches('[data-yg-blog-article-nav]')
            ? [context]
            : context.querySelectorAll('[data-yg-blog-article-nav]');

        roots.forEach(function (root) {
          window.YGBlogArticleNav.bind(root);
        });
      },
    };

    document.addEventListener('shopify:section:load', function (event) {
      window.YGBlogArticleNav.init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.YGBlogArticleNav.init(document);
    });
  } else {
    window.YGBlogArticleNav.init(document);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-blog-article-product"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ygBlogArticleDiscountConverted) return;
    window.__ygBlogArticleDiscountConverted = true;

    function convertDiscountAmount() {
      if (typeof Shopify === 'undefined' || !Shopify.currency) return;
      var rate = parseFloat(Shopify.currency.rate);
      if (!(rate > 0) || rate === 1) return;

      var badges = document.querySelectorAll('[data-yg-blog-discount-value]');
      for (var i = 0; i < badges.length; i++) {
        var badge = badges[i];
        var value = parseFloat(badge.getAttribute('data-yg-blog-discount-value'));
        if (isNaN(value)) continue;
        var converted = (Math.round(value * rate * 100) / 100).toFixed(2);
        badge.textContent = badge.textContent.replace(
          String(badge.getAttribute('data-yg-blog-discount-value')),
          converted
        );
      }
    }

    convertDiscountAmount();
    window.addEventListener('load', convertDiscountAmount);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-blog-article-related"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!window.YGBlogArticleRelated) {
      window.YGBlogArticleRelated = {
        init: function (root) {
          var scope = root || document;
          var components = [];

          if (scope.matches && scope.matches('[data-yg-blog-article-related]')) {
            components = [scope];
          } else if (scope.querySelectorAll) {
            components = Array.prototype.slice.call(scope.querySelectorAll('[data-yg-blog-article-related]'));
          }

          components.forEach(function (component) {
            if (component.dataset.initialized === 'true') return;

            var groups = Array.prototype.slice.call(component.querySelectorAll('[data-yg-blog-article-related-group]'));

            component.dataset.initialized = 'true';

            groups.forEach(function (group) {
              var toggle = group.querySelector('[data-yg-blog-article-related-toggle]');
              var panel = group.querySelector('.yg-blog-article-related__panel');
              if (!toggle || !panel) return;

              toggle.addEventListener('click', function () {
                var expanded = toggle.getAttribute('aria-expanded') === 'true';
                var nextExpanded = !expanded;

                /* Mutually exclusive: opening one closes the others. */
                if (nextExpanded) {
                  groups.forEach(function (otherGroup) {
                    if (otherGroup === group) return;

                    var otherToggle = otherGroup.querySelector('[data-yg-blog-article-related-toggle]');
                    var otherPanel = otherGroup.querySelector('.yg-blog-article-related__panel');
                    if (!otherToggle || !otherPanel) return;

                    otherToggle.setAttribute('aria-expanded', 'false');
                    otherPanel.setAttribute('aria-hidden', 'true');
                    otherPanel.setAttribute('inert', '');
                    otherGroup.classList.remove('is-expanded');
                  });
                }

                /* Same toggle pattern as FAQ enhanceFaqs. */
                toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
                panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');
                group.classList.toggle('is-expanded', nextExpanded);

                if (nextExpanded) {
                  panel.removeAttribute('inert');
                } else {
                  panel.setAttribute('inert', '');
                }
              });
            });
          });
        },
      };

      document.addEventListener('shopify:section:load', function (event) {
        window.YGBlogArticleRelated.init(event.target);
      });
    }

    window.YGBlogArticleRelated.init(document);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-multiport-video"] && !Shopify.designMode) return;
  try {
    class YGVideoLazyLoader extends HTMLElement {
    getLazyLoader() {
      if (!this._lazyLoader) {
        this._lazyLoader = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (entry.target.autoplay == 'true' && entry.target.popup == 'false') {
                  entry.target.playVideo();
                }
              } else {
                entry.target.stopVideoOnViewportExit();
              }
            });
          },
          {
            rootMargin: '0px',
          }
        );
      }
      return this._lazyLoader;
    }
  }

  class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.pauseVideoClick = this.pauseVideo.bind(this);
      this.handleViewportChange = this.handleViewportChange.bind(this);
      this.videoMediaQueries = window.matchMedia
        ? [
            window.matchMedia('(max-width: 402px)'),
            window.matchMedia('(min-width: 402.01px) and (max-width: 768px)'),
            window.matchMedia('(min-width: 768.01px) and (max-width: 1024px)'),
            window.matchMedia('(min-width: 1024.01px) and (max-width: 1440px)'),
            window.matchMedia('(min-width: 1440.01px)'),
          ]
        : [];
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
      this.activeVideoPort = this.currentVideoPort;
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    get currentVideoPort() {
      const width = window.innerWidth || document.documentElement.clientWidth || 0;

      if (width <= 402) return 'mobile';
      if (width <= 768) return 'tablet';
      if (width <= 1024) return 'desktop';
      if (width <= 1440) return 'large';

      return 'wide';
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', this.pauseVideoClick);
      this.addVideoMediaQueryListener();
      if (this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }
    }

    disconnectedCallback() {
      this.playVideoButton?.removeEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.removeEventListener('click', this.pauseVideoClick);
      this.removeVideoMediaQueryListener();
      if (this.popup == 'false') {
        this.getLazyLoader().unobserve(this);
      }
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.getCurrentVideoTemplate(),
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState('play');
      if (!this.videoContainer || !this.hasCurrentVideoVariant(this.videoContainer)) {
        this.videoContainer?.remove();
        this.appendCurrentVideoContainer();
      }
      this.activeVideoPort = this.currentVideoPort;

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach((video) => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.onended = () => this.handleVideoEnded();
          video.addEventListener('timeupdate', () => {
            if (video.duration && video.currentTime >= video.duration && this.loop == 'false') {
              this.pauseVideo();
              this.switcherVideoButtonState('pause');
            }
          });
        });
      }
    }

    handleVideoEnded() {
      if (this.loop == 'true') return;

      this.pauseVideo();
      this.switcherVideoButtonState('pause');
    }

    addVideoMediaQueryListener() {
      if (!this.videoMediaQueries.length || this.isVideoMediaQueryListenerAdded) return;

      this.videoMediaQueries.forEach((videoMediaQuery) => {
        if (videoMediaQuery.addEventListener) {
          videoMediaQuery.addEventListener('change', this.handleViewportChange);
        } else {
          videoMediaQuery.addListener(this.handleViewportChange);
        }
      });

      this.isVideoMediaQueryListenerAdded = true;
    }

    removeVideoMediaQueryListener() {
      if (!this.videoMediaQueries.length || !this.isVideoMediaQueryListenerAdded) return;

      this.videoMediaQueries.forEach((videoMediaQuery) => {
        if (videoMediaQuery.removeEventListener) {
          videoMediaQuery.removeEventListener('change', this.handleViewportChange);
        } else {
          videoMediaQuery.removeListener(this.handleViewportChange);
        }
      });

      this.isVideoMediaQueryListenerAdded = false;
    }

    handleViewportChange() {
      if (!this.videoContainer) return;

      const currentVideoPort = this.currentVideoPort;
      if (currentVideoPort === this.activeVideoPort) return;

      const shouldKeepContainerClosed = this.videoContainer.classList.contains('close');
      const shouldResumeVideo = this.isCurrentHtml5VideoPlaying() || this.autoplay == 'true';

      this.videoContainer.remove();
      this.appendCurrentVideoContainer();
      this.activeVideoPort = currentVideoPort;

      if (shouldKeepContainerClosed) {
        this.videoContainer?.classList.add('close');
        return;
      }

      if (this.type == 'video' && shouldResumeVideo) {
        this.videoContainer?.querySelectorAll('.yg-video-iframe').forEach((video) => video.play());
      } else if (this.type == 'video') {
        this.videoContainer?.querySelectorAll('.yg-video-iframe').forEach((video) => video.pause());
      }
    }

    appendCurrentVideoContainer() {
      if (!this.template) return;

      this.appendChild(this.getCurrentVideoFragment());
      this.activeVideoPort = this.currentVideoPort;
    }

    getCurrentVideoTemplate() {
      const template = document.createElement('template');

      template.content.appendChild(this.getCurrentVideoFragment());

      return template;
    }

    getCurrentVideoFragment() {
      const fragment = this.template?.content.cloneNode(true) || document.createDocumentFragment();
      const videoContainer = fragment.querySelector('.yg-video-iframe-container');

      this.keepCurrentVideoVariant(videoContainer);

      return fragment;
    }

    keepCurrentVideoVariant(videoContainer) {
      if (!videoContainer) return;

      const videos = Array.from(videoContainer.querySelectorAll('.yg-video-iframe'));
      const currentVideo = videos.find((video) => video.dataset.ygVideoPort === this.currentVideoPort);
      const videoToKeep = currentVideo || videos[0];

      videos.forEach((video) => {
        if (video !== videoToKeep) {
          video.remove();
        }
      });
    }

    hasCurrentVideoVariant(videoContainer) {
      if (!videoContainer) return false;

      const videos = Array.from(videoContainer.querySelectorAll('.yg-video-iframe'));
      const templateVideos = Array.from(this.template?.content.querySelectorAll('.yg-video-iframe') || []);
      const currentPort = this.currentVideoPort;
      const templateHasCurrentVideo = templateVideos.some((video) => video.dataset.ygVideoPort === currentPort);

      if (templateHasCurrentVideo) {
        return videos.some((video) => video.dataset.ygVideoPort === currentPort);
      }

      return videos.length > 0;
    }

    isCurrentHtml5VideoPlaying() {
      if (this.type != 'video' || !this.videoContainer) return false;

      return Array.from(this.videoContainer.querySelectorAll('.yg-video-iframe')).some(
        (video) => !video.paused && !video.ended
      );
    }

    isInlineVideoActive() {
      if (!this.videoContainer) return false;

      if (this.type == 'video') {
        return this.isCurrentHtml5VideoPlaying();
      }

      return !this.videoContainer.classList.contains('close');
    }

    stopVideoOnViewportExit() {
      if (this.popup == 'true' || !this.isInlineVideoActive()) return;

      this.pauseVideo();
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState('pause');

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach((video) => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState(state = 'play') {
      if (state == 'pause') {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == 'play') {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
